import { ANDROID, IOS } from 'constants/device';
import { DEFAULT_LANGUAGE } from 'constants/localization';

const AVAILABLE_LANGUAGES: Record<string, string> = {
    en: 'en-us',
    fr: 'fr-fr',
    de: 'de-de',
    it: 'it-it',
    es: 'es-es',
    pt: 'pt-br',
};

const BASE_LINK = 'https://help-centre.musclebooster.welltech.com/';

export const getFaqLinks = (lang: string, deviceOs: string) => {
    const languageCode = AVAILABLE_LANGUAGES[lang] || AVAILABLE_LANGUAGES[DEFAULT_LANGUAGE];
    const isMobileDevice = deviceOs === ANDROID || deviceOs === IOS;

    if (isMobileDevice) {
        return `${BASE_LINK}/${languageCode}?device=${deviceOs.toLowerCase()}`;
    }

    return `${BASE_LINK}${languageCode}`;
};
